/**
 * Shared PropTypes для VoiceWidget компонентов
 */

import PropTypes from 'prop-types';

/**
 * PropTypes для объекта темы
 */
export const themePropType = PropTypes.shape({
  variant: PropTypes.oneOf(['light', 'dark']),
  primaryColor: PropTypes.string,
  accentContrastColor: PropTypes.string,
  // accent: 'off' | 'bg' | 'buttons' (or boolean for backwards compatibility)
  accent: PropTypes.oneOfType([
    PropTypes.oneOf(['off', 'bg', 'buttons']),
    PropTypes.bool,
  ]),
  glass: PropTypes.bool,
  name: PropTypes.string,
  colors: PropTypes.object,
  sizing: PropTypes.object,
  spacing: PropTypes.object,
  radius: PropTypes.object,
});

/**
 * PropTypes для статуса соединения
 */
export const connectionStatusPropType = PropTypes.oneOf([
  'connecting',
  'connected',
  'disconnected',
]);

/**
 * PropTypes для языка
 */
export const languagePropType = PropTypes.oneOf(['en', 'ru', 'nl', 'fr', 'de', 'lu', 'el']);

/**
 * PropTypes для режима виджета
 */
export const widgetModePropType = PropTypes.oneOf(['voice', 'chat']);

/**
 * PropTypes для состояния виджета (окна)
 */
export const widgetStatePropType = PropTypes.oneOf([
  'minimized',
  'normal',
  'maximized',
]);

/**
 * PropTypes для сообщения в чате
 */
export const messagePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  role: PropTypes.oneOf(['user', 'assistant', 'system']).isRequired,
  text: PropTypes.string.isRequired,
});
